export default __webpack_public_path__ + "static/media/create_post_circle.91af536b.png";